<template>
  <div>
    <slot></slot>
    <template v-for="item in btnArray">
      <el-tooltip :disabled="item.tooltipMsg?false:true" :effect="item.effect" :content="item.tooltipMsg"
                  placement="top-start">
        <el-button :type="item.btnType" v-show="item.check(bound,status,xtStatus)" @click="clickPress(item.val)">
          {{item.name}}
        </el-button>
      </el-tooltip>
      <!--      <div v-if="item.tooltipMsg">-->
      <!--        {{item.name}}-->
      <!--      </div>-->
    </template>
  </div>
</template>

<script>
  import {sendButtonData, receiveButtonData} from '../../data/btnData';
  import {sendOutBound} from "../../data/statusData";

  export default {
    name: "btnShow",
    data() {
      return {
        sendButtonData: sendButtonData,
        sendButtonDataArray: [],
        receiveButtonData: receiveButtonData,
        receiveButtonDataArray: [],
        btnArray: [],
      }
    },
    props: {
      bound: [String, Object],
      status: [String, Object],
      xtStatus: [String, Object],
      flag: [String, Object],
    },
    created() {


    },
    mounted() {
      // console.log('this.status', this.xtStatus)
      // console.log(this.leftBtn)
      // for (let i in leftBtn) {
      //   let btn = eval('this.leftBtn.' + i)
      //   this.leftBtnArray.push(btn)
      // }

      for (let i in sendButtonData) {
        let btn = eval('this.sendButtonData.' + i)
        this.sendButtonDataArray.push(btn)
      }

      for (let i in receiveButtonData) {
        let btn = eval('this.receiveButtonData.' + i)
        this.receiveButtonDataArray.push(btn)
      }

      this.btnArray = this.flag == 'send' ? this.sendButtonDataArray : this.receiveButtonDataArray

    },
    methods: {
      clickPress(val) {
        console.log('val', val)

        let btn = this.btnArray.find(item => item.val == val)
        if (btn && btn.canClick) {//按钮可以点击
          this.btnArray.forEach(item => {
            if (item.val == val) {
              item.isPress = true
              item.onPress(this.bound, this.status, this.xtStatus)
            } else {
              item.isPress = false
            }
          })
        }


        //console.log('this.$parent.sendXtStatus.val',this.$parent.sendXtStatus)

        // if (val == this.leftBtn.orderCost.val) {
        //   this.leftBtn.orderCost.isPress = true
        //   console.log('按了:', this.leftBtn.orderCost)
        // }
      }
    }
  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/components/btnShow.vue